export const BRAND = {
  name: "Optimeo Habitat",
  logo: "https://customer-assets.emergentagent.com/job_ef37d0ec-bf02-41af-895f-67888d96f63d/artifacts/nsk4a11d_ChatGPT%20Image%2022%20juin%202026%2C%2020_44_25.png",
  slogan: "Réduisez vos factures avec des solutions de rénovation énergétique performantes",
  region: "Alsace · Bas-Rhin · Grand Est",
};

export const CONTACT = {
  whatsapp: process.env.REACT_APP_WHATSAPP_NUMBER || "33617161467",
  phoneDisplay: process.env.REACT_APP_PHONE_DISPLAY || "+33 6 17 16 14 67",
  phoneLink: (process.env.REACT_APP_PHONE_DISPLAY || "+33 6 17 16 14 67").replace(/\s/g, ""),
  calendly: process.env.REACT_APP_CALENDLY_URL || "https://calendly.com/optimeo-habitat/30min",
  email: process.env.REACT_APP_CONTACT_EMAIL || "contact@optimeo-habitat.fr",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1706164971302-e30c0640cc3b?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  pac: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  solar: "https://images.unsplash.com/photo-1655300256335-beef51a914fe?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  isolation: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  clim: "https://images.unsplash.com/photo-1631545308456-871da72cd8f4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  family: "https://images.unsplash.com/photo-1583608205776-bfd35f0d9f83?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  house1: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  house2: "https://images.unsplash.com/photo-1570129477492-45c003edd2be?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  technician: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  blog1: "https://images.unsplash.com/photo-1621905252189-08b45d6a269e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  blog2: "https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  blog3: "https://images.unsplash.com/photo-1518709268805-4e9042af9f23?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const SERVICES = [
  {
    slug: "pompe-a-chaleur",
    title: "Pompe à chaleur air/eau",
    tagline: "Jusqu'à 75% d'économies sur votre facture",
    image: IMAGES.pac,
    benefits: [
      "Chauffage + eau chaude sanitaire",
      "COP jusqu'à 5 (5 kWh produits pour 1 kWh consommé)",
      "Éligible MaPrimeRénov' et CEE",
      "Installation en 1 à 2 jours",
    ],
    savings: "Jusqu'à 1 800 €/an",
    aides: "Jusqu'à 11 000 €",
  },
  {
    slug: "climatisation",
    title: "Climatisation réversible",
    tagline: "Confort été comme hiver",
    image: IMAGES.clim,
    benefits: [
      "Chaud et froid en un seul équipement",
      "Marques premium (Daikin, Mitsubishi, Atlantic)",
      "Silencieux (< 22 dB)",
      "Pilotage smartphone",
    ],
    savings: "Confort thermique toute l'année",
    aides: "Éligible CEE",
  },
  {
    slug: "isolation",
    title: "Isolation thermique",
    tagline: "Combles, murs, planchers",
    image: IMAGES.isolation,
    benefits: [
      "Jusqu'à 30% d'économies immédiates",
      "Confort été et hiver",
      "Matériaux biosourcés disponibles",
      "Éligible aux aides à 1€*",
    ],
    savings: "Jusqu'à 900 €/an",
    aides: "Isolation combles à partir de 1€*",
  },
  {
    slug: "optimisation",
    title: "Optimisation énergétique",
    tagline: "Audit personnalisé de votre logement",
    image: IMAGES.house1,
    benefits: [
      "Audit thermique gratuit",
      "Recommandations sur mesure",
      "Priorisation des travaux",
      "Plan de financement optimisé",
    ],
    savings: "Économies dès la 1ère année",
    aides: "Étude gratuite",
  },
  {
    slug: "aides",
    title: "Accompagnement aux aides",
    tagline: "Nous montons tout le dossier pour vous",
    image: IMAGES.family,
    benefits: [
      "MaPrimeRénov' 2026",
      "CEE (Certificats d'Économie d'Énergie)",
      "Aides locales Alsace / Bas-Rhin",
      "Éco-PTZ jusqu'à 50 000 €",
    ],
    savings: "Jusqu'à 90% du projet financé",
    aides: "0€ à avancer sur certains dossiers",
  },
];

export const BLOG_POSTS = [
  {
    slug: "bien-choisir-pompe-a-chaleur-2026",
    title: "Comment bien choisir sa pompe à chaleur en 2026",
    excerpt: "COP, dimensionnement, marque, budget : le guide complet pour choisir la PAC air/eau adaptée à votre maison en Alsace.",
    date: "12 nov. 2026",
    readTime: "6 min",
    image: IMAGES.pac,
    category: "Pompe à chaleur",
    content: `Choisir une pompe à chaleur air/eau demande de prendre en compte plusieurs critères techniques et financiers. Voici les points essentiels à connaître avant de vous engager.\n\n**1. Le COP (Coefficient de Performance)**\nUn bon COP se situe entre 4 et 5. Cela signifie qu'avec 1 kWh d'électricité, la PAC restitue 4 à 5 kWh de chaleur. Plus il est élevé, plus votre facture baisse.\n\n**2. Le dimensionnement**\nUne PAC sous-dimensionnée forcera son fonctionnement, une PAC sur-dimensionnée sera moins efficace. Un audit thermique est indispensable.\n\n**3. Les marques recommandées**\nDaikin, Atlantic, Mitsubishi, Panasonic, Viessmann : ce sont les marques les plus fiables sur le marché français.\n\n**4. Les aides disponibles en Alsace**\nEn cumulant MaPrimeRénov', CEE et aides locales, vous pouvez financer jusqu'à 80% de votre installation. Notre équipe monte l'intégralité du dossier pour vous.`,
  },
  {
    slug: "maprimerenov-2026-ce-qui-change",
    title: "MaPrimeRénov' 2026 : ce qui change cette année",
    excerpt: "Nouveaux montants, nouveaux plafonds, nouveaux gestes éligibles. On fait le point sur les évolutions du dispositif.",
    date: "5 nov. 2026",
    readTime: "5 min",
    image: IMAGES.family,
    category: "Aides & financement",
    content: `MaPrimeRénov' évolue chaque année. En 2026, plusieurs changements importants sont à noter.\n\n**Des plafonds revalorisés**\nLes ménages modestes et très modestes bénéficient désormais d'aides plus élevées pour les rénovations d'ampleur.\n\n**Le parcours accompagné**\nPour les rénovations globales (2 gestes ou plus), un accompagnateur agréé est obligatoire. Notre bureau d'études est agréé pour vous accompagner de A à Z.\n\n**Les gestes éligibles**\nPAC air/eau, isolation, VMC double flux, chaudière biomasse : la liste des gestes prioritaires est étendue.\n\n**En pratique**\nNous vérifions gratuitement votre éligibilité et estimons votre aide en moins de 48h.`,
  },
  {
    slug: "isoler-combles-guide-complet",
    title: "Isoler ses combles : le guide complet 2026",
    excerpt: "Pourquoi c'est le meilleur investissement, quels matériaux choisir, à quelles aides prétendre.",
    date: "22 oct. 2026",
    readTime: "7 min",
    image: IMAGES.isolation,
    category: "Isolation",
    content: `L'isolation des combles est le poste #1 des déperditions énergétiques : jusqu'à 30% de la chaleur d'un logement s'échappe par le toit.\n\n**Les matériaux recommandés**\nLaine de roche, laine de bois, ouate de cellulose : chaque matériau a ses avantages selon votre configuration.\n\n**Résistance thermique R**\nUne R ≥ 7 m².K/W est exigée pour bénéficier des aides. Nous utilisons des matériaux certifiés ACERMI.\n\n**Combien ça coûte réellement ?**\nEn cumulant MaPrimeRénov', CEE et aides locales, l'isolation de combles peut revenir à partir de 1€ pour les ménages modestes.*\n\n**Retour sur investissement**\nJusqu'à 900€ d'économies par an, soit un retour en 2 à 4 ans.\n\n*Sous conditions de ressources et selon le devis.`,
  },
  {
    slug: "climatisation-reversible-hiver",
    title: "Peut-on chauffer avec une climatisation réversible ?",
    excerpt: "Oui, et efficacement. Découvrez comment une clim réversible peut remplacer votre chauffage électrique.",
    date: "10 oct. 2026",
    readTime: "4 min",
    image: IMAGES.clim,
    category: "Climatisation",
    content: `Une climatisation réversible (aussi appelée PAC air/air) peut effectivement assurer le chauffage principal d'un logement bien isolé.\n\n**Comment ça marche ?**\nLe cycle est inversé : la clim capte les calories de l'air extérieur pour les restituer à l'intérieur, même à -15°C sur les modèles récents.\n\n**Les économies**\nUne clim réversible consomme 3 fois moins qu'un chauffage électrique classique.\n\n**Points de vigilance**\nNécessite un logement isolé, et un dimensionnement précis. L'unité extérieure doit être placée correctement pour un fonctionnement optimal.\n\n**Aides**\nÉligible aux CEE.`,
  },
];

export const REVIEWS = [
  {
    name: "Sophie L.",
    location: "Strasbourg (67)",
    rating: 5,
    text: "Installation d'une PAC air/eau en 2 jours, équipe très pro et dossier MaPrimeRénov' monté de A à Z. J'ai économisé 1 400€ sur ma facture annuelle.",
    project: "Pompe à chaleur",
  },
  {
    name: "Julien M.",
    location: "Colmar (68)",
    rating: 5,
    text: "J'ai fait isoler mes combles et poser une clim réversible. Résultat: confort incroyable été comme hiver et facture divisée par 2. Merci Optimeo !",
    project: "Isolation + Clim",
  },
  {
    name: "Nathalie R.",
    location: "Haguenau (67)",
    rating: 5,
    text: "Étude gratuite très sérieuse, accompagnement top pour les aides. Le chantier a été impeccable, propre et rapide.",
    project: "Rénovation globale",
  },
  {
    name: "Franck B.",
    location: "Mulhouse (68)",
    rating: 5,
    text: "0€ d'avance grâce au montage des aides. Installation soignée, techniciens qualifiés RGE. Je recommande sans hésiter.",
    project: "Pompe à chaleur",
  },
];

export const FAQS = [
  {
    q: "Suis-je éligible à MaPrimeRénov' ?",
    a: "MaPrimeRénov' est ouverte à tous les propriétaires occupants ou bailleurs, sans condition de ressources pour la version « Ma Prime Rénov' Parcours par geste ». Le montant de l'aide varie selon vos revenus (barème bleu, jaune, violet, rose). Nous vérifions votre éligibilité gratuitement en 48h.",
  },
  {
    q: "Qu'est-ce que la CEE et est-elle cumulable avec MaPrimeRénov' ?",
    a: "Les Certificats d'Économie d'Énergie (CEE) sont une aide financée par les fournisseurs d'énergie. Oui, ils sont 100% cumulables avec MaPrimeRénov' et les aides locales. Notre équipe optimise le cumul pour maximiser votre aide.",
  },
  {
    q: "Quel est le délai entre l'étude et l'installation ?",
    a: "Compter en moyenne 4 à 8 semaines : 1 semaine pour l'étude, 3 à 6 semaines pour le montage du dossier d'aides et validation, puis 1 à 2 jours d'installation.",
  },
  {
    q: "Une pompe à chaleur est-elle rentable ?",
    a: "Oui, largement. Une PAC air/eau permet en moyenne 60 à 75% d'économies sur la facture de chauffage. Avec les aides, le retour sur investissement se fait en 4 à 7 ans.",
  },
  {
    q: "Puis-je bénéficier des aides si je suis locataire ?",
    a: "MaPrimeRénov' est réservée aux propriétaires. En tant que locataire, vous pouvez cependant bénéficier des CEE et devez obtenir l'accord de votre propriétaire pour les travaux. Nous pouvons monter le dossier avec le propriétaire.",
  },
  {
    q: "L'étude est-elle réellement gratuite ?",
    a: "Oui, l'étude thermique et le devis sont 100% gratuits et sans engagement. C'est notre garantie qualité.",
  },
  {
    q: "Quelles zones couvrez-vous ?",
    a: "Nous intervenons sur toute l'Alsace : Bas-Rhin (67), Haut-Rhin (68) et sur le Grand Est. Basés à proximité de Strasbourg, nous nous déplaçons rapidement.",
  },
  {
    q: "Vos installateurs sont-ils certifiés ?",
    a: "Oui, notre équipe est certifiée RGE (Reconnu Garant de l'Environnement), QualiPAC pour les pompes à chaleur, et Qualibat pour l'isolation. C'est indispensable pour bénéficier des aides.",
  },
];

export const PROCESS_STEPS = [
  { n: "01", title: "Étude gratuite", desc: "Audit thermique et échange sur votre projet à domicile ou en visio." },
  { n: "02", title: "Vérification éligibilité", desc: "Nous calculons vos aides précises sous 48h." },
  { n: "03", title: "Montage du dossier", desc: "MaPrimeRénov' + CEE + aides locales, on s'occupe de tout." },
  { n: "04", title: "Installation", desc: "Chantier soigné par nos techniciens RGE en 1 à 3 jours." },
  { n: "05", title: "Mise en service", desc: "Réglages, prise en main et contrôle qualité." },
  { n: "06", title: "Suivi & SAV", desc: "Entretien, garantie et accompagnement sur la durée." },
];
